/* jQuery(document).ready(function () {
  jQuery(".js-user-reviews-1").owlCarousel({
    navigation: true,

    slideSpeed: 300,
    paginationSpeed: 400,

    navigationText: [
      '<img src="https://cdn.shopify.com/s/files/1/0599/3824/2675/files/arrow-l-1.png?v=1716538496" alt="" />',
      '<img src="https://cdn.shopify.com/s/files/1/0599/3824/2675/files/arrow-r-1.png?v=1716538497" alt="" />',
    ],

    items: 1,
    itemsDesktop: false,
    itemsDesktopSmall: false,
    itemsTablet: false,
    itemsMobile: false,
  });
});
jQuery(document).ready(function () {
  jQuery(".js-before-after-1").owlCarousel({
    navigation: true,
    slideSpeed: 300,
    paginationSpeed: 400,

    navigationText: [
      '<img src="https://cdn.shopify.com/s/files/1/0599/3824/2675/files/arrow-l-2.png?v=1715970074" alt="" />',
      '<img src="https://cdn.shopify.com/s/files/1/0599/3824/2675/files/arrow-r-2.png?v=1715970095" alt="" />',
    ],

    items: 1,
    itemsDesktop: false,
    itemsDesktopSmall: false,
    itemsTablet: false,
    itemsMobile: false,
  });
});
jQuery(document).ready(function () {
  jQuery(".js-before-after-1-mobile").owlCarousel({
    navigation: true,

    slideSpeed: 300,
    paginationSpeed: 400,

    navigationText: [
      '<img src="https://cdn.shopify.com/s/files/1/0599/3824/2675/files/arrow-l-2.png?v=1715970074" alt="" />',
      '<img src="https://cdn.shopify.com/s/files/1/0599/3824/2675/files/arrow-r-2.png?v=1715970095" alt="" />',
    ],

    items: 1,
    itemsDesktop: false,
    itemsDesktopSmall: false,
    itemsTablet: false,
    itemsMobile: false,
  });
});*/
document.addEventListener("DOMContentLoaded", () => {
  document
    .getElementById("HeaderMenu-for-professionals")
    ?.setAttribute("target", "_blank");
});
